/**
 * File and filename utility functions
 */

/**
 * Generate timestamp in YYMMDD_HHMMSS format
 * @returns {string} Formatted timestamp string
 */
export const getTimestamp = () => {
  const now = new Date();
  const yy = now.getFullYear().toString().slice(-2);
  const mm = (now.getMonth() + 1).toString().padStart(2, '0');
  const dd = now.getDate().toString().padStart(2, '0');
  const hh = now.getHours().toString().padStart(2, '0');
  const min = now.getMinutes().toString().padStart(2, '0');
  const ss = now.getSeconds().toString().padStart(2, '0');
  return `${yy}${mm}${dd}_${hh}${min}${ss}`;
};

/**
 * Generate filename with timestamp and project name
 * @param {string} projectName - Name of the project
 * @param {string} extension - File extension (without dot)
 * @returns {string} Generated filename
 */
export const generateFilename = (projectName, extension) => {
  const timestamp = getTimestamp();
  const sanitizedProjectName = projectName.replace(/[^a-zA-Z0-9_-]/g, '_');
  return `${timestamp}_${sanitizedProjectName}.${extension}`;
};
